import {PlaceholderPackage, SupportedLanguage} from '@bitstillery/common/api/fact2server'

/**
 * The frontend packages a copy key can belong to: every `PlaceholderPackage` except `campaign` — email
 * copy is authored on its own page and is not part of the i18n bundle a client fetches. A client
 * requesting its own package always also receives `common`.
 */
export const I18N_PACKAGES = [PlaceholderPackage.Common, PlaceholderPackage.Discover, PlaceholderPackage.Portal] as const

export type I18nPackage = (typeof I18N_PACKAGES)[number]

const PORTAL_LANGUAGES = Object.values(SupportedLanguage)
// The discover admin app is authored in English and Dutch only.
const DISCOVER_LANGUAGES = [SupportedLanguage.EN_GB, SupportedLanguage.NL]

/**
 * Which languages a package's copy is authored in — the set the i18n tooling requires a translation
 * for, and the set a placeholder editor shows flags for. `common` copy ships to the portal as well, so
 * it carries the portal's full set rather than the intersection.
 */
export const PACKAGE_LANGUAGES: Record<I18nPackage, SupportedLanguage[]> = {
    common: PORTAL_LANGUAGES,
    discover: DISCOVER_LANGUAGES,
    portal: PORTAL_LANGUAGES,
}

/** The package the running app fetches its i18n bundle for. */
export function current_i18n_package(): I18nPackage {
    return process.env.MSI_PACKAGE === 'discover' ? PlaceholderPackage.Discover : PlaceholderPackage.Portal
}
